'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ExpandCollapseButton = require('./buttons/ExpandCollapseButton');

var _ExpandCollapseButton2 = _interopRequireDefault(_ExpandCollapseButton);

var _MoveSectionButton = require('./buttons/MoveSectionButton');

var _MoveSectionButton2 = _interopRequireDefault(_MoveSectionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @TODO convert to stateless function component
var SectionHeader = function (_Component) {
  _inherits(SectionHeader, _Component);

  function SectionHeader() {
    _classCallCheck(this, SectionHeader);

    return _possibleConstructorReturn(this, (SectionHeader.__proto__ || Object.getPrototypeOf(SectionHeader)).apply(this, arguments));
  }

  _createClass(SectionHeader, [{
    key: 'hashString',

    //Return an integer representation of the string
    value: function hashString(str) {
      var hash = 0;
      //if we didn't get a valid string return 0
      if (!str || str.length === 0) {
        return hash;
      }
      for (var i = 0; i < str.length; i++) {
        hash += str.charCodeAt(i);
      }
      return hash;
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon() {

      //Import all the icons
      var allergiesIcon = require('../resources/icons/CCD-Icon-01.png');
      var resultsIcon = require('../resources/icons/CCD-Icon-02.png');
      var careTeamIcon = require('../resources/icons/CCD-Icon-03.png');
      var contributorsIcon = require('../resources/icons/CCD-Icon-04.png');
      var vitalSignsIcon = require('../resources/icons/CCD-Icon-05.png');
      var medicalDevicesIcon = require('../resources/icons/CCD-Icon-06.png');
      var documentationIcon = require('../resources/icons/CCD-Icon-07.png');
      var datesIcon = require('../resources/icons/CCD-Icon-08.png');
      var problemsIcon = require('../resources/icons/CCD-Icon-09.png');
      var encountersIcon = require('../resources/icons/CCD-Icon-10.png');
      var immunizationsIcon = require('../resources/icons/CCD-Icon-11.png');
      var socialHistoryIcon = require('../resources/icons/CCD-Icon-12.png');
      var proceduresIcon = require('../resources/icons/CCD-Icon-13.png');
      var assessmentsIcon = require('../resources/icons/CCD-Icon-14.png');
      var treatmentPlanIcon = require('../resources/icons/CCD-Icon-15.png');
      var goalsIcon = require('../resources/icons/CCD-Icon-16.png');
      var healthConcernsIcon = require('../resources/icons/CCD-Icon-17.png');
      var reasonForReferralIcon = require('../resources/icons/CCD-Icon-18.png');
      var additionalFieldIcon1 = require('../resources/icons/CCD-Icon-10.png');
      var additionalFieldIcon2 = require('../resources/icons/CCD-Icon-28.png');

      var iconToRender = null;

      /*If we have a title, let's see if we can match it to an icon.
      This was purposefully done as an if else instead of a switch case so that we can
      use include to account for some variety in title names.
      TODO: This could potentially be refactored in the future when we have a more concrete idea of what sections we are getting.*/
      if (this.props.title && this.props.title !== null) {
        var title = this.props.title.toLowerCase();
        if (title.indexOf("allergies") !== -1) iconToRender = allergiesIcon;else if (title.indexOf("results") !== -1) iconToRender = resultsIcon;else if (title.indexOf("care team") !== -1) iconToRender = careTeamIcon;else if (title.indexOf("contributors") !== -1) iconToRender = contributorsIcon;else if (title.indexOf("vital") !== -1) iconToRender = vitalSignsIcon;else if (title.indexOf("devices") !== -1) iconToRender = medicalDevicesIcon;else if (title.indexOf("documentation") !== -1) iconToRender = documentationIcon;else if (title.indexOf("date") !== -1) iconToRender = datesIcon;else if (title.indexOf("problem") !== -1) iconToRender = problemsIcon;else if (title.indexOf("encounter") !== -1) iconToRender = encountersIcon;else if (title.indexOf("immunization") !== -1) iconToRender = immunizationsIcon;else if (title.indexOf("social") !== -1) iconToRender = socialHistoryIcon;else if (title.indexOf("procedure") !== -1) iconToRender = proceduresIcon;else if (title.indexOf("assessment") !== -1) iconToRender = assessmentsIcon;else if (title.indexOf("treatment") !== -1) iconToRender = treatmentPlanIcon;else if (title.indexOf("goal") !== -1) iconToRender = goalsIcon;else if (title.indexOf("concern") !== -1) iconToRender = healthConcernsIcon;else if (title.indexOf("referral") !== -1) iconToRender = reasonForReferralIcon;
      }
      //if we haven't found an icon for this title yet, assign a random icon.
      if (iconToRender === null) {
        var randomIconList = [];
        randomIconList.push(additionalFieldIcon1);
        randomIconList.push(additionalFieldIcon2);
        //set the icon to a random one from the list
        iconToRender = randomIconList[this.hashString(this.props.title) % randomIconList.length];
      }

      return _react2.default.createElement('img', { className: 'verticalAlign', src: iconToRender, alt: this.props.title + " icon", width: '30', height: '30' });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'dropShadow sectionHeader' },
        _react2.default.createElement(
          'div',
          { className: 'alignleft sectionTitleAndIcon' },
          this.renderIcon(),
          _react2.default.createElement(
            'h2',
            { className: 'indent-10' },
            this.props.title && this.props.title.toUpperCase()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'alignright no-wrap sectionTools' },
          _react2.default.createElement(_ExpandCollapseButton2.default, { isExpanded: this.props.isExpanded, toggleCollapseCB: this.props.toggleCollapseCB, id: this.props.id }),
          _react2.default.createElement(
            'span',
            { className: 'indent-15' },
            _react2.default.createElement(_MoveSectionButton2.default, { id: this.props.id, direction: -1, disabled: !this.props.moveUpEnabled, moveSectionCB: this.props.moveSectionCB })
          ),
          _react2.default.createElement(
            'span',
            { className: 'indent-15' },
            _react2.default.createElement(_MoveSectionButton2.default, { id: this.props.id, direction: 1, disabled: !this.props.moveDownEnabled, moveSectionCB: this.props.moveSectionCB })
          )
        )
      );
    }
  }]);

  return SectionHeader;
}(_react.Component);

SectionHeader.propTypes = {
  title: _propTypes2.default.string,
  isExpanded: _propTypes2.default.bool,
  moveUpEnabled: _propTypes2.default.bool,
  moveDownEnabled: _propTypes2.default.bool,
  moveSectionCB: _propTypes2.default.func,
  toggleCollapseCB: _propTypes2.default.func,
  id: _propTypes2.default.number
};

exports.default = SectionHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/SectionHeader.js
// module id = 1208
// module chunks = 0